/**
 * @file author-form.ts
 * @description Форма автора блога (phase19.16 Р1; uiux-design-r1 §7; SB58):
 * проверка (имя и «о себе» обязательны, Telegram и ВКонтакте — по реестру
 * контактов сайта) и сборка тела запроса (ник без «@» и адреса, `null`
 * очищает фото и соцсети).
 */

import { SITE_CONTACT_KINDS } from "@chaiberi/shared";

import type { UpdateAuthorInput } from "../api-content";
import type { SiteMedia } from "../site-view/types";

/** Значения формы автора. */
export interface AuthorForm {
  name: string;
  bio: string;
  photo: SiteMedia | null;
  telegram: string;
  vk: string;
}

/** Тело правки автора. */
export type AuthorPayload = Required<Pick<UpdateAuthorInput, "name" | "bio" | "photoMediaId" | "telegramHandle" | "vkHandle">>;

export function authorErrors(form: AuthorForm): Partial<Record<keyof AuthorForm, string>> {
  const errors: Partial<Record<keyof AuthorForm, string>> = {};
  if (!form.name.trim()) errors.name = "Укажите имя";
  if (!form.bio.trim()) errors.bio = "Пара предложений о себе — их видно под статьями";
  if (form.telegram.trim() && !SITE_CONTACT_KINDS.telegram.parse(form.telegram).ok) {
    errors.telegram = "Ник Telegram — латиница, цифры и _, от 5 знаков";
  }
  if (form.vk.trim() && !SITE_CONTACT_KINDS.vk.parse(form.vk).ok) {
    errors.vk = "Ссылка ВКонтакте должна вести на vk.com или vk.ru";
  }
  return errors;
}

export function authorInput(form: AuthorForm): AuthorPayload {
  const handle = (kind: "telegram" | "vk", raw: string) => {
    const parsed = raw.trim() ? SITE_CONTACT_KINDS[kind].parse(raw) : null;
    return parsed?.ok ? parsed.value : null;
  };
  return {
    name: form.name.trim(),
    bio: form.bio.trim(),
    photoMediaId: form.photo?.id ?? null,
    telegramHandle: handle("telegram", form.telegram),
    vkHandle: handle("vk", form.vk),
  };
}
